import { render } from "./AddCard.vue?vue&type=template&id=7189846d&ts=true"
import script from "./AddCard.vue?vue&type=script&lang=ts"
export * from "./AddCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__